import React from "react";
import styles from "./menu-bar.module.css";
import logoMenuItem from "../../../images/_finais/menu-item-logo_compress.webp";
import { NavLink } from "react-router-dom";

interface IMenuItem {
  mobileLabel: string;
  label: string;
  url: string;
}

interface IProps {
  items: IMenuItem[];
  page: any;
  onHandlePages: any;
}

const MenuBar = ({ items, page, onHandlePages }: IProps) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const onHandleMenuMobile = () => {
    return setIsMenuOpen((oldValue) => !oldValue);
  };

  const handleSelectedItem = (currentPage: string) => {
    if (currentPage !== page) {
      return styles.item_notSelected;
    }

    return styles.item_selected;
  };

  const handleLogoSelectedItem = (currentPage: string) => {
    if (currentPage !== page) {
      return styles.logoItem_notSelected;
    }

    return styles.logoItem_selected;
  };

  const handleSelectedItemMobile = (currentPage: string) => {
    if (currentPage !== page) {
      return styles.item_notSelectedMobile;
    }

    return styles.item_selectedMobile;
  };

  const handleClickMenuItemMobile = (label: string) => {
    setIsMenuOpen(false);

    onHandlePages(label);
  };

  return (
    <nav className={styles.nav}>
      <ul className={styles.menu_items}>
        <input type="checkbox" id={styles.checkbox_toggle} />
        <label
          htmlFor="checkbox_toggle"
          className={styles.hamburger}
          onClick={onHandleMenuMobile}
        >
          &#9776;
        </label>
        {items.map((item, index) => {
          const itemStyle = handleSelectedItem(item.label);
          const logoItemStyle = handleLogoSelectedItem(item.label);

          return (
            <li key={index} className={itemStyle}>
              <img
                className={logoItemStyle}
                src={logoMenuItem}
                alt="Logo item selected."
                loading="lazy"
              />
              <NavLink to={item.url} onClick={() => onHandlePages(item.label)}>
                {item.label}
              </NavLink>
            </li>
          );
        })}

        {isMenuOpen && (
          <nav className={styles.navBarMobile}>
            {items.map((item, index) => {
              const itemStyle = handleSelectedItemMobile(item.label);

              return (
                <li key={index} className={itemStyle}>
                  <NavLink
                    to={item.url}
                    onClick={() => handleClickMenuItemMobile(item.label)}
                  >
                    {item.mobileLabel}
                  </NavLink>
                </li>
              );
            })}
          </nav>
        )}
      </ul>
    </nav>
  );
};

export default MenuBar;
